import ScreenFill from '../../display/ui/ScreenFill';
import EndGameCopy from './EndGameCopy';

export default class EndGameOverlay extends Phaser.Group {
  constructor(game) {
    super(game);

    this.game.scale.onSizeChange.add(this.positionContainer, this);

    // track all layers and their key frames
    this.duration = 2; // seconds
    this.onScreenEnd = new Phaser.Signal();
    this.complete = false;

    this.x = (this.game.width - this.game.defaultWidth) / 2;
    this.y = (this.game.height - this.game.defaultHeight) / 2;

    // add screen dafe
    this.fade = new ScreenFill(this.game, 0x8a308a);
    this.addChildAt(this.fade, 0);

    this.vignette = this.game.make.image(0, 0, 'background_alt_overlay');
    this.fade.addChild(this.vignette);

    this.time = 0;

    // Add End Game copy
    this.copy = new EndGameCopy(this.game);
    this.add(this.copy);

    this.alpha = 0;

    this.beginFade();
  }

  beginFade() {
    // start fading in
    this.game.add
      .tween(this)
      .to({ alpha: 1 }, 500)
      .start();
  }

  positionContainer() {
    this.x = (this.game.width - this.game.defaultWidth) / 2;
    this.y = (this.game.height - this.game.defaultHeight) / 2;
  }

  dispatchEndOverlay() {
    this.onScreenEnd.dispatch();
  }

  /*
  =======================================================
    UPDATE
  =======================================================
  */

  update() {
    if (!this.complete) {
      this.time = this.time + 1 / 100;
      if (this.time > this.duration) {
        this.complete = true;

        // start fading in
        this.fadeOutTween = this.game.add.tween(this).to({ alpha: 0 }, 500);
        this.fadeOutTween.onComplete.add(this.dispatchEndOverlay, this);
        this.fadeOutTween.start();
      }
    }
  }

  destroy() {
    this.fade = null;
    this.copy = null;
    this.complete = false;
    this.time = 0;
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/endGame/EndGameOverlay.js